import type { ColDef, DataGridProps, GetRowIdFunc } from '@cmg/data-grid';

import type { TraitList_AccountTraitsQuery } from './graphql';

export type AccountTrait = TraitList_AccountTraitsQuery['accountTraits'][number];

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- AgGrid default ColDef type defaults generic params to any
export type TraitListColDef<TValue = any> = ColDef<AccountTrait, TValue>;

export const getRowId: GetRowIdFunc<AccountTrait> = params => {
  return params.data?.code ?? '';
};

export const autoSizeStrategy: DataGridProps<AccountTrait>['autoSizeStrategy'] = {
  type: 'fitCellContents',
};
